import { FC } from "react"
import React,{useEffect, useState, useMemo } from "react";
import { useIntl } from "react-intl"
import { PageTitle } from "../../../smallnation/layout/core"
import { KTSVG } from "../../../smallnation/helpers"
import services from "../../modules/services/services"
//import { useSearchParams } from 'react-router-dom'
import moment from "moment"
//import { useNavigate,useParams,useLocation,useHistory } from "react-router-dom";
import {  useLocation, useHistory } from "react-router-dom";
import { ErrorMessage } from "@hookform/error-message";
import { set, useForm } from "react-hook-form";
import $ from 'jquery';
//import {  BrowserRouter as Router, Link,  useLocation} from "react-router-dom";


//import { TablesWidget10, TablesWidget5,TablesWidget1, TablesWidget2,TablesWidget3,TablesWidget4,TablesWidget6,TablesWidget7,TablesWidget8,TablesWidget9,TablesWidget11,TablesWidget12,TablesWidget13  } from "../../../smallnation/partials/widgets"
//import { ProfileDirectoryInc } from "../../../smallnation/partials/widgets/tables/profileDirectoryInc"


const EditJobType: FC = () => {
      const intl = useIntl()
      let history = useHistory();
      const [jobtypeInfo, setjobtypeInfo] = useState([]);
      const red="red";
      const location99 = useLocation();
     const queryParams99 = new URLSearchParams(location99.search);
      const jobtypeId = queryParams99.get('jobtypeId');
      const jobtypeName = queryParams99.get('name');
      const {
        register,
        formState: { errors },
        handleSubmit
      } = useForm({
        criteriaMode: "all",mode: "onBlur" 
      });

      
      function getJobTypeById(){
          services.getJobTypesById(jobtypeId).then((res) => 
          {
            const myres = JSON.stringify(res);
            console.log(res.data.name);
            if(res){     
              $('#jobtype_name').val(res.data.name);        
            setjobtypeInfo(res.data); 
              //lert(res.data.eventTitle)
              //$("#eventTitle").val(res.data.eventTitle);  
            }  
          });
       }
      const submitValue = () => {
        var validateEditorTxt = 1;
        if($('#jobtype_name').val() == ""){
          $("#jobtypeNameValidMsg").show();  
          $(window).scrollTop($('#jobtypeNameValidMsg').position().top);
          validateEditorTxt = 0;     
        }else{
          $("#jobtypeNameValidMsg").hide();  
        }

        if(validateEditorTxt == 0){
          return false;
         } 
        const requestObject={
            "jobTypeId":jobtypeId,
            "name":$("#jobtype_name").val(),
        }
        console.log(requestObject);
        var accessTokenIn=sessionStorage.getItem("adminAccToken");
        const requestOptions = {
          method: 'POST',
          headers: { 'Content-Type': 'application/json',
                    'Authorization': "Bearer "+accessTokenIn 
                    //'Authorization': accessTokenIn 
                  },
          body: JSON.stringify(requestObject)
        };

        services.adminEditJobType(requestOptions).then((res) => 
        {
          if (res.code == '200') {
            $("#editjobtypesuccessMessage").fadeTo(2000, 500).slideUp(500, function () {
              $("#editjobtypesuccessMessage").slideUp(500);
            });
            setTimeout(() => {
              history.push('/jobtypelist');
            }, 1000);
          }
          else{
            $("#editjobtypefailMessage").fadeTo(2000, 500).slideUp(500, function () {
              $("#editjobtypefailMessage").slideUp(500);
            });
            setTimeout(() => {
              
            }, 1000);
          }
        });
        
      }
      useEffect(() => 
      {      
       getJobTypeById();
       //$('#jobtype_name').val(jobtypeName);
       $("#jobtypeNameValidMsg").hide(); 
       $('#editjobtypesuccessMessage').hide();
       $('#editjobtypefailMessage').hide();
      },[]);
      type Props = {
        className: string
      }
      return (
        <>
          <PageTitle breadcrumbs={[]}>{intl.formatMessage({id: 'Edit Job Type'})}</PageTitle>
         
          <form   onSubmit={handleSubmit(submitValue)}>     
             <div className="container">
               <div className="row">
                 

                 <div className="col-lg-12">
                 <div className="mb-4">
                 <div className="d-flex flex-column ">
                 <label htmlFor="exampleFormControlInput1" className="required form-label">Job Type Name</label>
                 
                 </div>
                  <input type="text" id="jobtype_name" name="jobtype_name" className="form-control" />
                   <div id="jobtypeNameValidMsg" style={{color:red}} className="error">Job Type Name is required.</div>
              </div>
                 </div>
                
                
                 <div className="col-lg-12">
                 <div className="mb-5 px-3">
                 <div className="d-flex flex-column ">
                 <div className="row mt-2">
                    <div className="divider"></div>
                    <button type="submit" className="btn btn-primary mt-10" style={{maxWidth: "200px"}}> Update Job Type </button>
                 </div>
                 </div>
                 <div id="editjobtypesuccessMessage" className="alert alert-success" role="alert">Job Type Updated Successfully</div>
                 <div id="editjobtypefailMessage" className="alert alert-danger" role="alert">Please try again</div>
              </div>
                 </div>

               </div>
             </div>
             </form>
        </>
      )
    }
export {EditJobType}